// Hydrates the quote form (sections/quote-form.liquid) from the POA CTA URL
// (/pages/quote?sku=&handle=&title=&vendor_code=) — Liquid can't read query
// params, so product context is filled here: hidden contact[] fields (carried
// into the notification email), a visible summary, and a default message.
// Without JS the form still submits; the customer just describes the product.
;(() => {
	const root = document.querySelector('[data-quote-form]')
	if (!root) return

	const params = new URLSearchParams(window.location.search)
	const sku = params.get('sku') || ''
	const title = params.get('title') || ''
	const vendorCode = params.get('vendor_code') || ''
	const handle = params.get('handle') || ''
	const url = handle ? `${window.location.origin}/products/${handle}` : ''

	const values = { title, sku, vendor_code: vendorCode, url }
	for (const [field, value] of Object.entries(values)) {
		const input = root.querySelector(`[data-quote-field="${field}"]`)
		if (input) input.value = value
	}

	// Nothing to prefill (someone opened /pages/quote directly) — leave the plain form.
	if (!title && !sku) return

	const summary = root.querySelector('[data-quote-summary]')
	const summaryText = root.querySelector('[data-quote-summary-text]')
	if (summary && summaryText) {
		const parts = [title || handle, sku && `SKU ${sku}`, vendorCode].filter(Boolean)
		summaryText.textContent = parts.join(' · ')
		summary.hidden = false
	}

	// Seed the message with the enquiry, leaving it editable.
	const body = document.getElementById('QuoteForm-body')
	if (body && body.value.trim() === '') {
		const label = title || sku
		body.value = `Please send me your best price for ${label}${sku ? ` (SKU ${sku})` : ''}.`
	}
})()
